export default {
  changeApiUrl({ commit }, apiUrl) {
    commit('setApiUrl', apiUrl);
  },
  changeGoogleClientId({ commit }, googleClientId) {
    commit('setGoogleClientId', googleClientId);
  },
  changeFacebookClientId({ commit }, facebookClientId) {
    commit('setFacebookClientId', facebookClientId);
  },
  changeCaptchaKey({ commit }, captchaKey) {
    commit('setCaptchaKey', captchaKey);
  },
};
